import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "app-text-field" }
const _hoisted_2 = {
  key: 0,
  class: "app-text-field__label"
}
const _hoisted_3 = ["placeholder"]

import Inputmask from 'inputmask';
import {
  onMounted,
  PropType,
  ref,
  watch,
  computed,
} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppTextField',
  props: {
  type: {
    type: String as PropType<'text' | 'number'>,
    required: false,
    default: 'text',
  },
  label: {
    type: String,
  },
  placeholder: {
    type: String,
  },
  mask: {
    type: Object as PropType<Inputmask.Instance>,
    required: false,
    default: null,
  },
  modelValue: {
    type: [String, Number] as PropType<string|number>,
    default: '',
  },
  autoUnmask: {
    type: Boolean,
    default: true,
  },
},
  emits: [
  'update:modelValue',
],
  setup(__props, { emit: __emit }) {

const inputEl = ref();
let maskInput: Inputmask.Instance | null = null;

const props = __props;

const emits = __emit;

const localValue = ref<any>(props.modelValue);

const unmaskedValue = computed(() => {
  let { value } = localValue;
  if (maskInput != null && props.autoUnmask) {
    maskInput.setValue(value);
    value = maskInput.unmaskedvalue();
  }
  if (props.type === 'number') {
    value = parseFloat(value);
    if (Number.isNaN(value)) {
      value = 0;
    }
  }
  return value;
});

watch(localValue, () => emits('update:modelValue', unmaskedValue.value));
watch(() => props.modelValue, (val: any) => {
  localValue.value = val;
});

onMounted(() => {
  if (props.mask) {
    maskInput = props.mask.mask(inputEl.value);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", _hoisted_1, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.label), 1))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localValue).value = $event)),
      type: "text",
      class: "app-text-field__input",
      placeholder: __props.placeholder,
      ref_key: "inputEl",
      ref: inputEl
    }, null, 8, _hoisted_3), [
      [_vModelText, localValue.value]
    ])
  ]))
}
}

})